import { render, staticRenderFns } from "./NewSputumCulture.vue?vue&type=template&id=ec2d7038&scoped=true&"
import script from "./NewSputumCulture.vue?vue&type=script&lang=js&"
export * from "./NewSputumCulture.vue?vue&type=script&lang=js&"
import style0 from "./NewSputumCulture.vue?vue&type=style&index=0&id=ec2d7038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2d7038",
  null
  
)

export default component.exports